import { View } from "react-native";
import React from "react";

import colors from "@constants/color";

const ShopSkeleton = () => {
  return (
    <View>
      <View>
        <View
          style={{
            width: 80,
            height: 25,
            alignSelf: "center",
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            borderRadius: 12,
            paddingHorizontal: 14,
            paddingVertical: 5,
            marginTop: 20,
            marginBottom: 4,
          }}
        />
        <View
          style={{
            height: 160,
            width: "90%",
            backgroundColor: "#ffffff",
            paddingTop: 16,
            paddingLeft: 16,
            borderRadius: 10,
            alignSelf: "center",
            marginTop: 16,
            elevation: 6,
            shadowColor: colors.lightMediumBlack,
          }}
        >
          <View
            style={{
              height: 20,
              width: "80%",
              backgroundColor: "rgba(0,0,0,0.1)",
              marginBottom: 10,
            }}
          />
          <View>
            <View
              style={{
                height: 20,
                width: "60%",
                backgroundColor: "rgba(0,0,0,0.1)",
                marginTop: 10,
              }}
            />
            <View
              style={{
                height: 20,
                width: "60%",
                backgroundColor: "rgba(0,0,0,0.1)",
                marginTop: 10,
              }}
            />
          </View>
          <View
            style={{
              marginTop: 10,
              height: 20,
              width: "20%",
              backgroundColor: "rgba(0,0,0,0.1)",
            }}
          />
        </View>
      </View>
      <View>
        <View
          style={{
            height: 160,
            width: "90%",
            backgroundColor: "#ffffff",
            paddingTop: 16,
            paddingLeft: 16,
            borderRadius: 10,
            alignSelf: "center",
            marginTop: 16,
            elevation: 6,
            shadowColor: colors.lightMediumBlack,
          }}
        >
          <View
            style={{
              height: 20,
              width: "80%",
              backgroundColor: "rgba(0,0,0,0.1)",
              marginBottom: 10,
            }}
          />
          <View>
            <View
              style={{
                height: 20,
                width: "60%",
                backgroundColor: "rgba(0,0,0,0.1)",
                marginTop: 10,
              }}
            />
            <View
              style={{
                height: 20,
                width: "60%",
                backgroundColor: "rgba(0,0,0,0.1)",
                marginTop: 10,
              }}
            />
          </View>
          <View
            style={{
              marginTop: 10,
              height: 20,
              width: "20%",
              backgroundColor: "rgba(0,0,0,0.1)",
            }}
          />
        </View>
      </View>
      <View>
        <View
          style={{
            height: 160,
            width: "90%",
            backgroundColor: "#ffffff",
            paddingTop: 16,
            paddingLeft: 16,
            borderRadius: 10,
            alignSelf: "center",
            marginTop: 16,
            elevation: 6,
            shadowColor: colors.lightMediumBlack,
          }}
        >
          <View
            style={{
              height: 20,
              width: "80%",
              backgroundColor: "rgba(0,0,0,0.1)",
              marginBottom: 10,
            }}
          />
          <View>
            <View
              style={{
                height: 20,
                width: "60%",
                backgroundColor: "rgba(0,0,0,0.1)",
                marginTop: 10,
              }}
            />
            <View
              style={{
                height: 20,
                width: "60%",
                backgroundColor: "rgba(0,0,0,0.1)",
                marginTop: 10,
              }}
            />
          </View>
          <View
            style={{
              marginTop: 10,
              height: 20,
              width: "20%",
              backgroundColor: "rgba(0,0,0,0.1)",
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default ShopSkeleton;
